<div>
  <div class="section-home-cover">
    <div class="section-home-cover-bg">
      <div
        [utBgImg]="coverBg"
        [swap]="headerData?.data?.coverBg?.large"
      ></div>
    </div>
    <div class="container-fluid block">
      @if (currentUser) {
        <a
          id="coverBtn"
          uiSref="newarticle"
          class="btn new-article"
          (click)="checkLightTester($event)"
          >
          <span class="icon icon-write" aria-hidden="true"></span>Write an Article
        </a>
      }
      <h1 class="section-title">{{headerData?.data?.title}}</h1>
      <p class="section-desc" [innerHTML]="headerData?.data?.description"></p>
    </div>
  </div>

  <div class="container-fluid block">
    <div style="padding-bottom:1rem;">
      <h2>Official uTest Articles</h2>
    </div>
    <div class="article-feed-grid">
      @for (article of officialArticles?.feedItems ?? []; track article.id) {
        <ut-article-card [article]="article"></ut-article-card>
      }
    </div>
    <ut-load-more
      [isLoading]="officialArticles?.isLoading || false"
      [isLastPage]="officialArticles?.isLastPage || false"
      (loadMore)="officialArticles?.loadMore()"
    ></ut-load-more>
  </div>

  <div class="container-fluid">
    <div style="padding-bottom:1rem;">
      <h3>Community uTest Articles</h3>
    </div>
    <div class="article-feed-grid">
      @for (article of contributedArticles?.feedItems ?? []; track article.id) {
        <ut-article-card [article]="article"></ut-article-card>
      }
    </div>
    <ut-load-more
      [isLoading]="contributedArticles?.isLoading || false"
      [isLastPage]="contributedArticles?.isLastPage || false"
      (loadMore)="contributedArticles?.loadMore()"
    ></ut-load-more>
  </div>

  <div class="container-fluid">
    <div style="padding-bottom:1rem;">
      <h4>Most Popular uTest Articles</h4>
    </div>
    <div class="article-feed-grid">
      @for (article of popularArticles?.feedItems ?? []; track article.id) {
        <ut-article-card [article]="article"></ut-article-card>
      }
    </div>
    <ut-load-more
      [isLoading]="popularArticles?.isLoading || false"
      [isLastPage]="popularArticles?.isLastPage || false"
      (loadMore)="popularArticles?.loadMore()"
    ></ut-load-more>
  </div>
</div>
